<footer class="footer container">
  <p class="copyright">&copy; Informatrix</p>
</footer>
